import { WorkspaceLayoutEnum } from './enum.model';

export class WorkspaceConfigModel {
    layout: WorkspaceLayoutEnum = WorkspaceLayoutEnum.SINGLE;
}
